import React, { forwardRef, useState, useImperativeHandle, useEffect } from 'react'
import { Modal, notification, Table, Tag, ConfigProvider, Transfer } from 'antd'
import { getAccountList, setOrgFinancialAccount, setOrgPayAccount } from '../../../common/request'
import ResponseCode from '../../../common/response-code'
import { difference } from 'lodash'

const EditFinancialAccountModal = forwardRef((props, ref) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [tableData, setTableData] = useState({})
  const [notifyApi, contextHolder] = notification.useNotification()
  const [tableDataLoading, setTableDataLoading] = useState(true)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [pageNum, setPageNum] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  useEffect(() => {
    if (modalVisible) {
      getTableData()
      setSelectedRowKeys(props.accountList.map(item => {
        return item.accountId
      }))
    }
  }, [modalVisible])

  const columns = [
    {
      width: 130,
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone'
    },
    {
      title: '账户名',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '角色',
      dataIndex: 'roleName',
      key: 'roleName',
      render: (roleName) => {
        return (<>
          <Tag color="blue">{ roleName }</Tag>
        </>)
      }
    }
  ]

  const showModal = () => {
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
  }

  const getTableData = () => {
    setTableDataLoading(true)
    const params = {
      pageSize: 999,
      pageNum: 1,
      orderType: 'DESC',
      orderBy: 'id',
      roleTag: 'financial'
    }

    getAccountList(params).then(res => {
      setTableDataLoading(false)
      if (res.code === ResponseCode.success && res.data) {
        setTableData(res.data)
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      setTableDataLoading(false)
      Modal.error({
        title: '网络错误',
        content: '查询权限失败',
        centered: true
      })
    })
  }

  const onOk = () => {
    const params = {
      id: props.orgItem.id,
      fincialUserIdList: selectedRowKeys
    }

    setOrgFinancialAccount(params).then(res => {
      if (res.code === ResponseCode.success) {
        hideModal()
        notifyApi.success({
          message: '操作成功'
        })
        props.insertSuccess && props.insertSuccess()
      } else {
        Modal.error({
          title: '错误',
          content: res.msg,
          centered: true
        })
      }
    }).catch(() => {
      Modal.error({
        title: '网络错误',
        content: '设置财务人员失败',
        centered: true
      })
    })
  }

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const paginationChange = (num, size) => {
    setPageNum(num)
    setPageSize(size)
  }

  return (
    <div ref={ ref }>
      { contextHolder }

      <Modal
        title="配置财务人员"
        width={ 900 }
        open={ modalVisible }
        onOk={ onOk }
        onCancel={ hideModal }
      >
        <ConfigProvider componentSize="small">
          <Transfer
            titles={ ['财务人员列表', '已选财务人员'] }
            dataSource={ tableData.elements }
            targetKeys={ selectedRowKeys }
            rowKey={ (record) => {
              return record.accountId
            } }
            showSearch={ true }
            onChange={ onSelectChange }
            filterOption={ (inputValue, item) =>
              item.name.includes(inputValue) || item.phone.includes(inputValue)
            }
          >
            { ({
                 direction,
                 filteredItems,
                 onItemSelect,
                 onItemSelectAll,
                 selectedKeys: listSelectedKeys,
                 disabled: listDisabled
               }) => {

              return <Table
                size="small"
                scroll={ {
                  y: 300
                } }
                rowKey={ (record) => {
                  return record.accountId
                } }
                style={ { pointerEvents: listDisabled ? 'none' : undefined } }
                pagination={ {
                  showTotal: (total) => {
                    return `共 ${ total } 条`
                  },
                  total: filteredItems.length,
                  pageSize: pageSize,
                  current: pageNum,
                  onChange: paginationChange
                } }
                dataSource={ filteredItems }
                rowSelection={ {
                  getCheckboxProps: (item) => ({
                    disabled: listDisabled || item.disabled
                  }),
                  onSelectAll (selected, selectedRows) {
                    const treeSelectedKeys = selectedRows
                    .filter((item) => !item.disabled)
                    .map(({ key }) => key)
                    const diffKeys = selected
                      ? difference(treeSelectedKeys, listSelectedKeys)
                      : difference(listSelectedKeys, treeSelectedKeys)
                    onItemSelectAll(diffKeys, selected)
                  },
                  onSelect ({ key }, selected) {
                    onItemSelect(key, selected)
                  },
                  selectedRowKeys: listSelectedKeys
                } }
                columns={ columns }
                onRow={ ({ key, disabled: itemDisabled }) => ({
                  onClick: () => {
                    if (itemDisabled || listDisabled) return
                    onItemSelect(key, !listSelectedKeys.includes(key))
                  }
                }) }
              ></Table>
            } }
          </Transfer>
        </ConfigProvider>
      </Modal>
    </div>
  )
})

export default EditFinancialAccountModal
